import {memo} from 'react';
import {UniversityData} from '@/map/@types';
import {AROUND_DATA_OPTIONS} from '@/map/constants';
import {AreaAnalyticsFilter} from '@/map/enums';
import {NearbyInfoMarker} from './Marker';

interface IProps extends naver.maps.MarkerOptions {
  item: UniversityData;
}

export const UniversityMarker = memo(
  ({map, position, item}: IProps) => {
    return (
      <NearbyInfoMarker
        typeInfo={AROUND_DATA_OPTIONS[AreaAnalyticsFilter.UNIVERSITY]}
        config={{
          map,
          position,
        }}
        item={{
          name: item.name,
          count: item.studentsCount,
        }}
      />
    );
  },
  (prevProps: IProps, nextProps: IProps) => {
    return prevProps.position.toString() === nextProps.position.toString();
  }
);
